// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__haAUf","overlay":"Settings_overlay__7Olnv","button":"Settings_button__tEsqO","description":"Settings_description__RVsyz"};